var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"white",attrs:{"label":"Sponsorship","items":_vm.data,"item-text":"name","item-value":"id"},model:{value:(_vm.id),callback:function ($$v) {_vm.id=$$v},expression:"id"}})}
var staticRenderFns = []

export { render, staticRenderFns }